// extracted by mini-css-extract-plugin
export var noSpinners = "_p6-6";
export var percentageInput = "_p6-7";
export var variantColor1 = "_p6-0";
export var variantColor2 = "_p6-1";
export var variantColor3 = "_p6-2";
export var variantColor4 = "_p6-3";
export var variantColor5 = "_p6-4";
export var variantColor6 = "_p6-5";